import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import axios from "axios";
import AdminNav from "./AdminNav";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { Modal } from "antd";

const WithdrawDetailsC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [withdraw, setWithdraw] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [loading, setLoading] = useState(false);

  // Approve modal state
  const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);
  const [fromWallet, setFromWallet] = useState("");
  const [toWallet, setToWallet] = useState("");
  const [transactionHash, setTransactionHash] = useState("");
  const [notes, setNotes] = useState("");

  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");

  useEffect(() => {
    const fetchWithdrawData = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/withdraw/get-withdraw-c/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          setWithdraw(data.withdrawRequest);
          setToWallet(data.withdrawRequest?.walletAddress || "");
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchWithdrawData();
  }, [id, token]);

  // Approve handler -> opens modal
  const handleApproveModal = () => setIsApproveModalVisible(true);

  // Final approve submit
  const handleApproveSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/api/v1/withdraw/approve-c/${id}`,
        {
          status: "approved",
          fromWallet,
          toWallet,
          transactionHash,
          notes,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 200 && res.data.success) {
        toast.success(res.data.message);
        navigate("/dashboard/admin/withdrawals");
      } else {
        toast.error(
          res.data.message || "Something went wrong. Please try again."
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("Approval failed. Try again.");
    } finally {
      setLoading(false);
      setIsApproveModalVisible(false);
    }
  };

  const handleRejectModal = () => setIsRejectModalVisible(true);

  const submitRejection = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/api/v1/withdraw/reject-c/${id}`,
        { rejectReason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        toast.success("Withdrawal Request Rejected Successfully");
        navigate("/dashboard/admin/withdrawals");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to reject withdrawal request. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="wrapper d-flex align-items-stretch">
        {loading && <Loader />}
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2 pt-3">
          <button type="button" onClick={toggleSidebar} className="bars-btn">
            <FaBarsStaggered />
          </button>
          <AdminNav />

          <div className="shadow-lg rounded-3 p-4 deposit-card">
            <h4 className="mb-3 text-uppercase">Withdrawal request Details </h4>

            <div className="border my-2 rounded-2 px-3 py-2">
              <label className="d-flex justify-content-between mb-2">
                <span>User Name :</span>
                <span>{withdraw?.userId?.name || "N/A"}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>User Email :</span>
                <span>{withdraw?.userId?.email || "N/A"}</span>
              </label>

              <label className="d-flex justify-content-between mb-2">
                <span>Asset:</span>
                <span>{withdraw?.asset}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Network:</span>
                <span>{withdraw?.network || "N/A"}</span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Amount:</span>
                <span>
                  {withdraw?.amount} {withdraw?.asset}
                </span>
              </label>
              <label className="d-flex justify-content-between mb-2">
                <span>Withdrawal Address:</span>
                <span>{withdraw?.walletAddress}</span>
              </label>
            </div>

            {withdraw.status === "pending" && (
              <div className="d-flex justify-content-end mt-3">
                <button
                  onClick={handleApproveModal}
                  className="text-success bg-transparent border-0 mx-3"
                >
                  APPROVE
                </button>
                <button
                  onClick={handleRejectModal}
                  className="text-danger bg-transparent border-0 mx-3"
                >
                  REJECT
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Approve Modal */}
      <Modal
        open={isApproveModalVisible}
        footer={null}
        onCancel={() => setIsApproveModalVisible(false)}
      >
        <form onSubmit={handleApproveSubmit}>
          <h4 className="mb-4">Approve Withdrawal Request</h4>

          <div className="mb-3">
            <label>From Wallet</label>
            <input
              type="text"
              className="form-control"
              value={fromWallet}
              onChange={(e) => setFromWallet(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>To Wallet</label>
            <input
              type="text"
              className="form-control"
              value={toWallet}
              disabled
            />
          </div>
          <div className="mb-3">
            <label>Transaction Hash</label>
            <input
              type="text"
              className="form-control"
              value={transactionHash}
              onChange={(e) => setTransactionHash(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Notes</label>
            <textarea
              className="form-control"
              rows={3}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>

          <div className="mt-3 text-end">
            <button type="submit" className="btn btn-success">
              Approve
            </button>
          </div>
        </form>
      </Modal>

      {/* Reject Modal */}
      <Modal
        open={isRejectModalVisible}
        footer={null}
        onCancel={() => setIsRejectModalVisible(false)}
      >
        <form>
          <h4 className="mb-4">Reject Withdrawal Request</h4>
          <div className="mb-1 d-flex flex-column">
            <label>Rejection Reason</label>
            <textarea
              className="wallet-address-input"
              rows={4}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              required
              placeholder="Reason for rejection"
            />
          </div>
          <div className="mt-3 text-end">
            <button
              type="button"
              onClick={submitRejection}
              className="btn btn-danger"
            >
              Reject
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default WithdrawDetailsC;
